export default __webpack_public_path__ + "static/media/lovely.6e0ed0cc.svg";